/**
 * Traffic Tracker Module
 * Theo dõi nguồn traffic (referrer, UTM parameters)
 */

import * as StateManager from './state-manager.js';
import { getTrafficTrackingData, saveTrafficTrackingData } from './storage-service.js';

/**
 * Track traffic source (referrer, UTM parameters)
 */
export function trackTrafficSource() {
    const now = Date.now();

    // Get URL parameters
    const urlParams = new URLSearchParams(window.location.search);

    // Current session data
    const currentSource = {
        referrer: document.referrer || 'direct',
        landing_page: window.location.href,
        utm_source: urlParams.get('utm_source') || '',
        utm_medium: urlParams.get('utm_medium') || '',
        utm_campaign: urlParams.get('utm_campaign') || '',
        utm_content: urlParams.get('utm_content') || '',
        utm_term: urlParams.get('utm_term') || '',
        timestamp: now
    };

    // Parse referrer to get source name
    currentSource.source_name = parseReferrerSource(currentSource.referrer);

    // Get existing tracking data
    let trackingData = getTrafficTrackingData();

    // First touch attribution (only save if not exists)
    if (!trackingData.first_touch) {
        trackingData.first_touch = currentSource;
    }

    // Last touch attribution (always update)
    trackingData.last_touch = currentSource;

    // Save to localStorage
    saveTrafficTrackingData(trackingData);

    // Set global variable for form submission
    StateManager.setSourceTracking(trackingData);

    console.log('Traffic source tracked:', trackingData);
}

/**
 * Parse referrer to get readable source name
 */
function parseReferrerSource(referrer) {
    if (!referrer || referrer === 'direct') {
        return 'Direct / None';
    }

    try {
        const url = new URL(referrer);
        const hostname = url.hostname.toLowerCase();

        // Social media sources
        if (hostname.includes('facebook.com') || hostname.includes('fb.com')) {
            return 'Facebook';
        }
        if (hostname.includes('instagram.com')) {
            return 'Instagram';
        }
        if (hostname.includes('tiktok.com')) {
            return 'TikTok';
        }
        if (hostname.includes('youtube.com')) {
            return 'YouTube';
        }
        if (hostname.includes('zalo.me')) {
            return 'Zalo';
        }
        if (hostname.includes('linkedin.com')) {
            return 'LinkedIn';
        }
        if (hostname.includes('twitter.com') || hostname.includes('x.com')) {
            return 'Twitter/X';
        }
        if (hostname.includes('pinterest.com')) {
            return 'Pinterest';
        }

        // Search engines
        if (hostname.includes('google.com') || hostname.includes('google.')) {
            return 'Google Search';
        }
        if (hostname.includes('bing.com')) {
            return 'Bing Search';
        }
        if (hostname.includes('yahoo.com')) {
            return 'Yahoo Search';
        }
        if (hostname.includes('coccoc.com')) {
            return 'Cốc Cốc Search';
        }

        // Default: return hostname
        return hostname;
    } catch (e) {
        return referrer;
    }
}

/**
 * Get traffic source for form submission
 */
export function getTrafficSourceForSubmission() {
    const sourceTracking = StateManager.getSourceTracking();
    const data = sourceTracking.last_touch || sourceTracking.first_touch;

    if (!data) {
        return {
            source: 'Direct / None',
            referrer: '',
            utm_source: '',
            utm_medium: '',
            utm_campaign: ''
        };
    }

    return {
        source: data.source_name || 'Unknown',
        referrer: data.referrer || '',
        landing_page: data.landing_page || '',
        utm_source: data.utm_source || '',
        utm_medium: data.utm_medium || '',
        utm_campaign: data.utm_campaign || '',
        utm_content: data.utm_content || '',
        utm_term: data.utm_term || '',
        first_touch_source: sourceTracking.first_touch ? sourceTracking.first_touch.source_name : '',
        first_touch_date: sourceTracking.first_touch ? new Date(sourceTracking.first_touch.timestamp).toISOString() : ''
    };
}
